export const AwardIcons = [
  'First Place Gold Medal',
  'Second Place Silver Medal',
  'Third Place Bronze Medal',
  'Honorable Mention',
  'Best Innovation',
  'Trophy',
  'Generic Medal',
  'Gold Star',
  'Silver Star',
  'Bronze Star',
];

export const AwardIcon = ({ icon }) => {
  if (!AwardIcons.includes(icon)) {
    return <></>;
  }

  switch (icon) {
    case 'First Place Gold Medal':
      return (
        <span
          role="img"
          aria-label="First Place Gold Medal"
          style={{ fontSize: '1.5em' }}
        >
          🥇
        </span>
      );
    case 'Second Place Silver Medal':
      return (
        <span
          role="img"
          aria-label="Second Place Silver Medal"
          style={{ fontSize: '1.5em' }}
        >
          🥈
        </span>
      );
    case 'Third Place Bronze Medal':
      return (
        <span
          role="img"
          aria-label="Third Place Bronze Medal"
          style={{ fontSize: '1.5em' }}
        >
          🥉
        </span>
      );
    case 'Honorable Mention':
      return (
        <span
          role="img"
          aria-label="Honorable Mention"
          style={{ fontSize: '1.5em' }}
        >
          🏅
        </span>
      );
    case 'Best Innovation':
      return (
        <span
          role="img"
          aria-label="Best Innovation"
          style={{ fontSize: '1.5em' }}
        >
          💡
        </span>
      );
    case 'Trophy':
      return (
        <span role="img" aria-label="Trophy" style={{ fontSize: '1.5em' }}>
          🏆
        </span>
      );
    case 'Generic Medal':
      return (
        <span
          role="img"
          aria-label="Generic Medal"
          style={{ fontSize: '1.5em' }}
        >
          🎖️
        </span>
      );
    case 'Gold Star':
      return (
        <span role="img" aria-label="Gold Star" style={{ fontSize: '1.5em' }}>
          ⭐
        </span>
      );
    case 'Silver Star':
      return (
        <span role="img" aria-label="Silver Star" style={{ fontSize: '1.5em' }}>
          🌟
        </span>
      );
    case 'Bronze Star':
      return (
        <span role="img" aria-label="Bronze Star" style={{ fontSize: '1.5em' }}>
          ✨
        </span>
      );
    default:
      return <></>;
  }
};
